/* eslint-disable @typescript-eslint/naming-convention */
export const environment = {
  production: false,
  env: 'testing',
  locale: 'fr',
  main_newspapers: 'mquo, lepq, actu, aeco',
  environments: {
    development: {
      domain: 'http://localhost:8081',
      client: '',
      secret: '',
    },
    testing: {
      // domain: 'https://api.playbacpresse.fr',
      domain: 'https://digital-api.test.playbacpresse.fr',
      // client_id: '1_4oho2wllwkkkk0g00k40go4ok4ocs04okg4k00c8sskskk0ww4',
      // client_secret: '613hzd35bmccg0gcw4gokw884wokco8k4ck484s4sgso0k088o',
      client_id: '1_4k6qzb479ekgk0kk8gokk8kww04g8w8kkswskkwc48gcckcskc',
      client_secret: '3jj4of4ey22ogcoo8ocwww848wgk4k40kksscws88wswg4sc84',
    },
    preprod: {
      domain: 'https://api.playbacpresse.fr',
      client_id: '1_4oho2wllwkkkk0g00k40go4ok4ocs04okg4k00c8sskskk0ww4',
      client_secret: '613hzd35bmccg0gcw4gokw884wokco8k4ck484s4sgso0k088o',
    },
    prod: {
      domain: 'http://api.playbacpresse.fr',
      client: '',
      secret: '',
    },
  },
  newspapers: [
    { domain: 'monquotidien.dev', class: 'mquo', name: 'Mon Quotidien' },
    { domain: 'lepetitquotidien.dev', class: 'lepq', name: 'Le Petit Quotidien' },
    { domain: 'l-actu.dev', class: 'actu', name: 'L\'Actu' },
    { domain: 'l-eco.dev', class: 'aeco', name: 'L’Éco' },
    { domain: 'playbacpress.dev', class: 'playbacpresse', name: 'PlayBac Press' },
    { domain: 'localhost', class: 'playbacpresse', name: 'PlayBac Press' },
    { domain: 'myweekly.dev', class: 'week', name: 'MyWeekly' },
    { domain: 'mylittleweekly.dev', class: 'mlwk', name: 'MyLittleWeekly' },
    { domain: 'misemanal.dev', class: 'sema', name: 'MyWeekly' },
    { domain: 'meinewoche.dev', class: 'woch', name: 'MyWeekly' },
    { domain: 'myweeklynews.dev', class: 'mwne', name: 'MyWeeklyNews' },
    { domain: 'mylittleweeklynews.dev', class: 'mlne', name: 'MyLittleWeeklyNews' },
    // TEST
    { domain: 'm-digital.test.playbacpresse.fr', class: 'playbacpresse', name: 'PlayBac Presse' },
    { domain: 'm-lepetitquotidien.test.playbacpresse.fr', class: 'lepq', name: 'Le Petit Quotidien' },
    { domain: 'm-monquotidien.test.playbacpresse.fr', class: 'mquo', name: 'Mon Quotidien' },
    { domain: 'm-lactu.test.playbacpresse.fr', class: 'actu', name: 'L\'ACTU' },
    { domain: 'm-leco.test.playbacpresse.fr', class: 'aeco', name: 'L\'ECO' },
    { domain: 'm-mylittleweekly.test.playbacpresse.fr', class: 'mlwk', name: 'My Little Weely' },
    { domain: 'm-myweekly.test.playbacpresse.fr', class: 'week', name: 'My Weely' },
    { domain: 'm-meinewoche.test.playbacpresse.fr', class: 'woch', name: 'Meine Woche' },
    { domain: 'm-misemanal.test.playbacpresse.fr', class: 'sema', name: 'Mi Semanal' },
    { domain: 'm-monquotidienvideo.test.playbacpresse.fr', class: 'mquovideo', name: 'Mon Quotidien Video' },
    { domain: 'm-lactuvideo.test.playbacpresse.fr', class: 'actuvideo', name: 'L\'ACTU Video' },
    { domain: 'm-mylittleweekly.test.playbac.jp', class: 'mljp', name: 'My Little Weekly JP' },
    { domain: 'm-myweekly.test.playbac.jp', class: 'mwjp', name: 'My Weekly JP' },
    { domain: 'm-mylittleweekly.test.playbac.de', class: 'mlde', name: 'My Little Weekly JP' },
    { domain: 'm-myweekly.test.playbac.de', class: 'mwde', name: 'My Weekly JP' },
    { domain: 'm-clarify.test.playbac.com', class: 'clfy', name: 'Clarify' },
    { domain: 'm-myweeklynews.test.playbacpresse.fr', class: 'mwne', name: 'My Weely News' },
    { domain: 'm-mylittleweeklynews.test.playbacpresse.fr', class: 'mlne', name: 'My Little Weely News' },
    // PROD
    { domain: 'm-digital.playbacpresse.fr', class: 'playbacpresse', name: 'PlayBac Presse' },
    { domain: 'm-lepetitquotidien.playbacpresse.fr', class: 'lepq', name: 'Le Petit Quotidien' },
    { domain: 'm-monquotidien.playbacpresse.fr', class: 'mquo', name: 'Mon Quotidien' },
    { domain: 'm-lactu.playbacpresse.fr', class: 'actu', name: 'L\'ACTU' },
    { domain: 'm-leco.playbacpresse.fr', class: 'aeco', name: 'L\'ECO' },
    { domain: 'm-myweekly.playbacpresse.fr', class: 'week', name: 'My Weekly' },
    { domain: 'm-myweeklynews.playbacpresse.fr', class: 'mwne', name: 'My Weekly News' },
    { domain: 'm-meinewoche.playbacpresse.fr', class: 'woch', name: 'Meine Woche' },
    { domain: 'm-misemanal.playbacpresse.fr', class: 'sema', name: 'Mi Semanal' },
    { domain: 'm-mylittleweekly.playbacpresse.fr', class: 'mlwk', name: 'My Little Weekly' },
    { domain: 'm-mylittleweeklynews.playbacpresse.fr', class: 'mlne', name: 'My Little Weekly News' },
    // PREPROD
    { domain: 'm-digital-preprod.playbacpresse.fr', class: 'playbacpresse', name: 'Playbac Presse' },
    { domain: 'm-lepetitquotidien-preprod.playbacpresse.fr', class: 'lepq', name: 'Le Petit Quotidien' },
    { domain: 'm-monquotidien-preprod.playbacpresse.fr', class: 'mquo', name: 'Mon Quotidien' },
    { domain: 'm-lactu-preprod.playbacpresse.fr', class: 'actu', name: 'L\'ACTU' },
    { domain: 'm-leco-preprod.playbacpresse.fr', class: 'aeco', name: 'L\'ECO' },
    { domain: 'm-myweekly-preprod.playbacpresse.fr', class: 'week', name: 'My Weekly' },
    { domain: 'm-meinewoche-preprod.playbacpresse.fr', class: 'woch', name: 'Meine Woche' },
    { domain: 'm-misemanal-preprod.playbacpresse.fr', class: 'sema', name: 'Mi Semanal' },
    { domain: 'm-mylittleweekly-preprod.playbacpresse.fr', class: 'mlwk', name: 'My Little Weekly' },
    { domain: 'm-myweeklynews-preprod.playbacpresse.fr', class: 'mwne', name: 'My Weekly News' },
    { domain: 'm-mylittleweeklynews-preprod.playbacpresse.fr', class: 'mlne', name: 'My Little Weekly News' },
  ],
  all_newspapers: [
    { name: 'Le Petit Quotidien', subname: 'lepq', url: 'https://m-lepetitquotidien.test.playbacpresse.fr/' },
    { name: 'Mon Quotidien', subname: 'mquo', url: 'https://m-monquotidien.test.playbacpresse.fr/' },
    { name: 'L\'ACTU', subname: 'actu', url: 'https://m-lactu.test.playbacpresse.fr/' },
    { name: 'L\'ÉCO', subname: 'aeco', url: 'https://m-leco.test.playbacpresse.fr/' },
    { name: 'My Weekly', subname: 'week', url: 'https://m-myweekly.test.playbacpresse.fr/' },
    { name: 'My Weekly News', subname: 'mwne', url: 'https://m-myweeklynews.test.playbacpresse.fr/' },
    { name: 'Meine Woche', subname: 'woch', url: 'https://m-meinewoche.test.playbacpresse.fr/' },
    { name: 'Mi Semanal', subname: 'sema', url: 'https://m-misemanal.test.playbacpresse.fr/' },
    { name: 'Mon Quotidien Vidéo', subname: 'mquovideo', url: 'https://m-monquotidienvideo.test.playbacpresse.fr/' },
    { name: 'L\'ACTU Vidéo', subname: 'actuvideo', url: 'https://m-lactuvideo.test.playbacpresse.fr/' },
    { name: 'My Little Weekly News', subname: 'mlne', url: 'https://m-mylittleweeklynews.test.playbacpresse.fr/' },
    { name: 'My Little Weekly', subname: 'mlwk', url: 'https://m-mylittleweekly.test.playbacpresse.fr/' }
  ],
  all_newspapers_preprod: [
    { name: 'Le Petit Quotidien', subname: 'lepq', url: 'https://m-lepetitquotidien-preprod.playbacpresse.fr' },
    { name: 'Mon Quotidien', subname: 'mquo', url: 'https://m-monquotidien-preprod.playbacpresse.fr' },
    { name: 'L\'ACTU', subname: 'actu', url: 'https://m-lactu-preprod.playbacpresse.fr' },
    { name: 'L\'ÉCO', subname: 'aeco', url: 'https://m-leco-preprod.playbacpresse.fr' },
    { name: 'My Weekly', subname: 'week', url: 'https://m-myweekly-preprod.playbacpresse.fr' },
    { name: 'My Weekly News', subname: 'mwne', url: 'https://m-myweeklynews-preprod.playbacpresse.fr' },
    { name: 'Meine Woche', subname: 'woch', url: 'https://m-meinewoche-preprod.playbacpresse.fr' },
    { name: 'Mi Semanal', subname: 'sema', url: 'https://m-misemanal-preprod.playbacpresse.fr' },
    { name: 'Mon Quotidien Video', subname: 'mquovideo', url: 'http://m-monquotidienvideo-preprod.playbacpresse.fr/' },
    { name: 'L\'actu Vidéo', subname: 'actuvideo', url: 'https://m-lactuvideo-preprod.playbacpresse.fr' },
    { name: 'My Little Weekly News', subname: 'mlne', url: 'https://m-mylittleweeklynews-preprod.playbacpresse.fr' },
    { name: 'My Little Weekly', subname: 'mlwk', url: 'https://m-mylittleweekly-preprod.playbacpresse.fr' }
  ],
  all_newspapers_prod: [
    { name: 'Le Petit Quotidien', subname: 'lepq', url: 'https://m-lepetitquotidien.playbacpresse.fr' },
    { name: 'Mon Quotidien', subname: 'mquo', url: 'https://m-monquotidien.playbacpresse.fr' },
    { name: 'L\'ACTU', subname: 'actu', url: 'https://m-lactu.playbacpresse.fr' },
    { name: 'L\'ÉCO', subname: 'aeco', url: 'https://m-leco.playbacpresse.fr' },
    { name: 'My Weekly', subname: 'week', url: 'https://m-myweekly.playbacpresse.fr' },
    { name: 'My Weekly News', subname: 'mwne', url: 'https://m-myweeklynews.playbacpresse.fr' },
    { name: 'Meine Woche', subname: 'woch', url: 'https://m-meinewoche.playbacpresse.fr' },
    { name: 'Mi Semanal', subname: 'sema', url: 'https://m-misemanal.playbacpresse.fr' },
    { name: 'My Little Weekly News', subname: 'mlne', url: 'https://m-mylittleweeklynews.playbacpresse.fr' },
    { name: 'My Little Weekly', subname: 'mlwk', url: 'https://m-mylittleweekly.playbacpresse.fr' }
  ],
};
